import React, { ReactNode } from "react";
import { Typography } from "@mui/material";
import { OptionButton } from "shared/components/Inputs/OptionButton";
import { SurveyLayoutIcon } from "./SurveyLayoutIcons";
import { SurveyLayouts } from "modules/MainSurveyEditor/helpers/blockForm";
import { BlockTypes } from "modules/MainSurveyEditor/helpers/blocks";
import { ScatterChartImg } from "shared/images/charts/scatter";
import { BarChartImg } from "shared/images/charts/bar";
import { LineChartImg } from "shared/images/charts/line";
import { PieChartImg } from "shared/images/charts/pie";

const LayoutOptions: LayoutOption[] = [
  {
    value: SurveyLayouts.Wizard,
    icon: <SurveyLayoutIcon type={SurveyLayouts.Wizard} />,
    name: "Wizard",
    blockTypes: [BlockTypes.MainSurvey, BlockTypes.Survey],
  },
  {
    value: SurveyLayouts.Simple,
    icon: <SurveyLayoutIcon type={SurveyLayouts.Simple} />,
    name: "Simple",
    blockTypes: [BlockTypes.MainSurvey, BlockTypes.Survey],
  },
  {
    value: SurveyLayouts.Scatter,
    icon: <ScatterChartImg />,
    name: "Scatter",
    blockTypes: [BlockTypes.Chart],
  },
  {
    value: SurveyLayouts.Bar,
    icon: <BarChartImg />,
    name: "Bar",
    blockTypes: [BlockTypes.Chart],
  },
  {
    value: SurveyLayouts.Line,
    icon: <LineChartImg />,
    name: "Line",
    blockTypes: [BlockTypes.Chart],
  },
  {
    value: SurveyLayouts.Pie,
    icon: <PieChartImg />,
    name: "Pie",
    blockTypes: [BlockTypes.Chart],
  },
];

export const SurveyLayoutField = (props: SurveyLayoutFieldProps) => {
  const { onChange, selectedValue = SurveyLayouts.Wizard, blockType = BlockTypes.Survey } = props;

  const filteredOptions = LayoutOptions.filter(({ blockTypes }) => blockTypes.includes(blockType));

  return (
    <div className="module-survey-layout-field">
      {filteredOptions.map(({ value, icon, name }) => (
        <OptionButton
          key={value}
          content={
            <div className="_d-flex-dir-col-ali-center-md-gap">
              {icon}
              <Typography>{name}</Typography>
            </div>
          }
          value={value}
          selectedValue={selectedValue}
          onClick={() => onChange(value)}
        />
      ))}
    </div>
  );
};

interface SurveyLayoutFieldProps {
  onChange: (value: string) => void;
  selectedValue?: string;
  blockType?: BlockTypes;
}

type LayoutOption = {
  value: string;
  icon: ReactNode;
  name: string;
  blockTypes: BlockTypes[];
};
